import React, { useState, useEffect } from 'react';
import '../css/components/ManageProfile.css';
import Loading from '../general/Loading';

const StaffDashboard = ({ userData, setResponse }) => {
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    user_name: '',
    mobile: '',
    permission: '',
    role: '',
    pass: '',
  });

  const [parsedPermissions, setParsedPermissions] = useState([]);

  useEffect(() => {
    if (userData) {
      setFormData({
        user_name: userData.name || '',
        mobile: userData.mobile || '',
        permission: userData.permission || '',
        role: userData.role || '',
        pass: userData.pass || '',
      });

      // Parse permission JSON safely
      try {
        const perms = JSON.parse(userData.permission);
        if (Array.isArray(perms)) {
          setParsedPermissions(perms);
        }
      } catch (err) {
        console.error('Failed to parse permissions:', err);
        setParsedPermissions([]);
      }
    }
  }, [userData]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  return (
    <>
      <section className='my-4'>
        <div className='px-4'>
          <p className='page-title'>My Profile Details</p>

          <div className='row g-3 mt-1'>
            {[
              { label: 'Your Name', name: 'user_name' },
              { label: 'Mobile', name: 'mobile', type: 'tel' },
              { label: 'Role', name: 'role' },
              { label: 'Password', name: 'pass' },
            ].map(({ label, name, type = 'text' }) => (
              <div key={name}>
                <div className='profile-input px-0'>
                  <label className='profile-label'>{label}</label>
                  <input
                    type={type}
                    className='profile-control'
                    name={name}
                    value={formData[name]}
                    onChange={handleInputChange}
                    // disabled={!isEditing}
                  />
                </div>
              </div>
            ))}

            {/* PERMISSIONS DISPLAY */}
            <div className='col-12'>
              <div className='profile-input py-3'>
                <label className='profile-label'>Permissions</label>
                <div className='permission-list'>
                  {parsedPermissions.length > 0 ? (
                    parsedPermissions.map((perm, idx) => (
                      <span key={idx} className='badge fw-semibold bg-success py-2 me-2'>
                        {perm}
                      </span>
                    ))
                  ) : (
                    <span className='text-muted'>No permissions assigned.</span>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {loading && <Loading setLoading={setLoading} />}
    </>
  );
};

export default StaffDashboard;
